import Portfolio from '../portfolio';

/**
 * Create the action
 */

const { thunk, request, success, error } = Portfolio.store((data, fetch) => {
    return fetch.post('/portfolios', data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
